// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconNet = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M7.2 2.917c0 .339-.107.65-.29.908l.73 1.546q.369-.079.76-.08a3.6 3.6 0 0 1 2.358.871l2.052-1.489a1.593 1.593 0 0 1 1.59-1.757c.883 0 1.6.71 1.6 1.584 0 .873-.717 1.583-1.6 1.583a1.6 1.6 0 0 1-.645-.133l-2.05 1.49a3.538 3.538 0 0 1 .117 2.523l1.8 1.068c.23-.126.495-.198.778-.198.883 0 1.6.71 1.6 1.584C16 13.29 15.283 14 14.4 14s-1.6-.71-1.6-1.583v-.028l-1.803-1.07A3.6 3.6 0 0 1 8.4 12.416a3.59 3.59 0 0 1-3.51-2.771H2.985a1.6 1.6 0 0 1-1.385.791c-.883 0-1.6-.71-1.6-1.583s.718-1.583 1.6-1.583a1.6 1.6 0 0 1 1.385.792h1.903A3.56 3.56 0 0 1 6.19 6.04l-.73-1.546A1.59 1.59 0 0 1 4 2.917c0-.874.718-1.584 1.6-1.584s1.6.71 1.6 1.584m1.2 7.125c.662 0 1.2-.532 1.2-1.188s-.537-1.187-1.2-1.187-1.2.532-1.2 1.187c0 .656.537 1.188 1.2 1.188'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconNet)
const Memo = memo(ForwardRef)
export default Memo
